var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loadingVolumeData),expression:"loadingVolumeData"}],attrs:{"element-loading-spinner":"qc-spinner","loading":_vm.loadingVolumeData}},[_c('canvas',{attrs:{"id":"volumeGraph"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }